// extracted by css-extract-rspack-plugin
export default {"s_panel_wrap":"SyHRwOeQVYGCUk3g","title":"kdnDJvoxHiIZg2rc","fixed":"DFzugLDTjEA8Q2N9","s_clickable":"BUG0tCELqIUDbjNT","s_drains_down":"XjljM8_PHsQ4dIL2"};